import { Button } from "@/components/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.tsx";
import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import { DialogDescription } from "@radix-ui/react-dialog";
import React from "react";

export interface DeleteStrategicInitiativeDialogProps {
  isOpen: boolean;
  isDeleting: boolean;
  close: () => void;
  remove: () => void;
}

const DeleteStrategicInitiativeDialog: React.FC<
  DeleteStrategicInitiativeDialogProps
> = ({ isOpen, isDeleting, close, remove }) => {
  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="w-[600px]">
        <DialogHeader>
          <DialogTitle>Remove a strategic initiative</DialogTitle>
          <DialogDescription>
            Are you sure you want to remove this strategic initiative?
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-full">
          <div className="flex items-center w-full gap-2">
            <div className="flex-1"></div>
            <Button
              className="bg-sky-100 text-black rounded-full pl-12 pr-12 justify-central"
              disabled={isDeleting}
              onClick={close}
            >
              <span className="flex-1">Cancel</span>
            </Button>
            <Button
              className="bg-sky-500 rounded-full pl-12 pr-12 justify-central"
              disabled={isDeleting}
              onClick={remove}
            >
              <span className="flex-1">Remove</span>
            </Button>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteStrategicInitiativeDialog;
